module.exports = __webpack_public_path__ + "assets/img/202110-2.1eb0bacc.png";